An action that can be executed as part of a workflow process.
